import { makeStyles } from "@material-ui/core";
import { ColorsDisplay } from "../../../../../styles/Color";

export const useStyles = makeStyles(theme => ({
    containerDisplay: {
        width: "100vw",
        height: "100vh",
        backgroundColor: ColorsDisplay.background,
        "& .rounded-display": {
            [theme.breakpoints.up(1922)]: {
                borderRadius: 35,
            },
            [theme.breakpoints.down(1923)]: {
                borderRadius: 6,
            },
        },
        "& .text-red": {
            color: ColorsDisplay.redTheme,
        },
        "& .border-color-r-primary": {
            [theme.breakpoints.up(1922)]: {
                borderRight: "4px solid " + ColorsDisplay.blueTheme,
            },
            [theme.breakpoints.down(1923)]: {
                borderRight: "2px solid " + ColorsDisplay.blueTheme,
            },
        },
        "& .border-color-l-primary": {
            [theme.breakpoints.up(1922)]: {
                borderLeft: "4px solid " + ColorsDisplay.blueTheme,
            },
            [theme.breakpoints.down(1923)]: {
                borderLeft: "2px solid " + ColorsDisplay.blueTheme,
            },
        },
        "& .header-title": {
            background: ColorsDisplay.blueTheme,
        },
        "& .footer-text": {
            background: ColorsDisplay.blueTheme,
            color: "#fff",
            paddingTop: "0.5rem",
            paddingBottom: "0.5rem",
        },
        "& .title-rooms, & .title-doctor, & .title-currentQ": {
            background: ColorsDisplay.blueTheme,
            padding: "0.5rem",
            color: "#ffffff",
            marginBottom: "0.5rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            [theme.breakpoints.up(1922)]: {
                lineHeight: 1.6,
            },
            [theme.breakpoints.down(1923)]: {
                lineHeight: 1.2,
            },
        },
        "& .title-currentQ": {
            [theme.breakpoints.up(1922)]: {
                lineHeight: "0.85 !important",
            },
            [theme.breakpoints.down(1923)]: {
                lineHeight: 1.2,
            },
        },
        "& .boxtitle-queue": {
            [theme.breakpoints.up(1922)]: {
                minHeight: 125,
            },
            [theme.breakpoints.down(1923)]: {
                minHeight: 80,
            },
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
    },
    btnUpsizeFont: {
        "& .MuiButtonGroup-groupedOutlinedHorizontal": {
            border: "none",
        },
        "& .MuiButtonBase-root.MuiButton-root": {
            backgroundColor: "#fefefe",
            paddingTop: 11,
            paddingBottom: 11,
            lineHeight: 1.4,
        },
        "& .MuiButton-label svg": {
            width: 40,
            height: 40,
        },
        "& .text-show-value": {
            fontSize: "calc(100% + 16px)",
            lineHeight: 1.4,
        },
    },
    textMarquee: {
        [theme?.breakpoints.up("1923")]: { minHeight: 100 },
        [theme?.breakpoints.down("1922")]: { minHeight: 40 },
        overflow: "hidden",
        position: "relative",
        display: "flex",
        alignItems: "center",
        "& p": {
            position: "absolute",
            minWidth: "100%",
            margin: 0,
            textAlign: "center",
            transform: "translateX(100%)",
            animation: "marquee_text 20s linear infinite",
            whiteSpace: "nowrap",
            color: "inherit",
            fontWeight: 600,
        },
    },
}));

export const useZoomStyle = zoom => {
    return makeStyles(theme => ({
        container: {
            [theme?.breakpoints.up("1923")]: {
                "& .text-sm": {
                    fontSize: `calc(100% + (10px * ${zoom}))`,
                },
                "& .text-md": {
                    fontSize: `calc(100% + (14px * ${zoom}))`,
                },
                "& .text-lg": {
                    fontSize: `calc(100% + (22px * ${zoom}))`,
                },
                "& .text-xl": {
                    fontSize: `calc(100% + (82px * ${zoom}))`,
                },
                "& .text-2xl": {
                    fontSize: `calc(100% + (82px * ${zoom}))`,
                },
                "& .text-3xl": {
                    fontSize: `calc(100% + (230px * ${zoom}))`,
                },
                "& .text-4xl": {
                    fontSize: `calc(100% + (360px * ${zoom}))`,
                },
                "& .text-call": {
                    fontSize: `calc(100% + (42px * ${zoom}))`,
                },
                "& .text-call-number": {
                    fontSize: `calc(100% + (74px * ${zoom}))`,
                },
            },
            [theme?.breakpoints.down("1922")]: {
                "& .text-sm": {
                    fontSize: `calc(10px * ${zoom})`,
                },
                "& .text-md": {
                    fontSize: `calc(16px * ${zoom})`,
                },
                "& .text-lg": {
                    fontSize: `calc(18px * ${zoom})`,
                },
                "& .text-xl": {
                    fontSize: `calc(28px * ${zoom})`,
                },
                "& .text-2xl": {
                    fontSize: `calc(34px * ${zoom})`,
                },
                "& .text-3xl": {
                    fontSize: `calc(44px * ${zoom})`,
                },
                "& .text-4xl": {
                    fontSize: `calc(64px * ${zoom})`,
                },
                "& .text-call": {
                    fontSize: `calc(26px * ${zoom})`,
                },
                "& .text-call-number": {
                    fontSize: `calc(46px * ${zoom})`,
                },
            },
        },
    }));
};
